import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// Capture URL parameters before React initializes
const captureUrlParams = () => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    const queryId = searchParams.get('queryId');  // Added this line to define queryId
    const llmQueryId = searchParams.get('llmQueryId');

    if (llmQueryId) {
      console.log('URL Parameter detected, capturing llmQueryId:', llmQueryId);
      localStorage.setItem('pendingLlmQueryId', llmQueryId);
      localStorage.setItem('pendingQueryTimestamp', Date.now().toString());
    } else if (queryId) {
      // For backward compatibility during transition
      console.log('Legacy URL Parameter detected, capturing for conversion:', queryId);
      localStorage.setItem('pendingQueryId', queryId);
      localStorage.setItem('pendingQueryTimestamp', Date.now().toString());
    }
  } catch (error) {
    console.error('Error capturing URL parameters:', error);
  }
};

// Run the capture function before React initializes
captureUrlParams();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);